import { DisplayPosition } from '@/type/display-position';
// import { CnRating, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '评分',
    componentName: 'CnRating',
    // component: CnRating,
    // formComponent: formComponentMap.CnRating,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getPrototypeList: () => {
        return [
            {
                name: 'allowHalf',
                title: '允许半星评分',
                display: 'inline',
                setter: 'BoolSetter',
            },
            {
                name: 'count',
                title: '评分总数',
                display: 'inline',
                setter: 'NumberSetter',
            },
        ];
    },
};
